import React from "react";
import { useTranslation } from "react-i18next";
import "./ModalPopup.css"; // Import CSS for styling
import useModalTransition from "../hooks/useModalTransition";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faChevronRight, faGrip, faListOl, faPhone, faXmark } from "@fortawesome/free-solid-svg-icons";

const CommonModalPopup = ({isOpen,closeModal,data}) => {
    const { isMounted, isClosing } = useModalTransition(isOpen, closeModal);
    const { t } = useTranslation();


    function openDialpad(phoneNumber) {
        // Create a temporary "tel:" URL
        const telUrl = `tel:${phoneNumber}`;

        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = telUrl;
        link.style.display = 'none';

        // Append the link to the document
        document.body.appendChild(link);

        // Simulate a click on the link
        link.click();

        // Remove the temporary link
        document.body.removeChild(link);
      }

    if (!isMounted || (data.content !== 'CHART_INFO' && data.content !== 'CONNECT_SUPPORT')) return null;

    const isChart = data.content === 'CHART_INFO';
    const titleId = isChart ? 'chart-info-title' : 'support-title';

  return (
        <div className={`modal-overlay${isClosing ? " is-closing" : ""}`} onClick={(e) => e.target === e.currentTarget && closeModal()}>
          <div className="modal-content info-modal" role="dialog" aria-modal="true" aria-labelledby={titleId}>
            <div className="info-modal-head">
              <div className="info-modal-heading">
                <h2 id={titleId} className="info-modal-title">{isChart ? t('modals.chartInfo') : t('modals.contactSupport')}</h2>
                <p className="info-modal-sub">{isChart ? data.game_name?.split('_').join(' ') : `+91${data.phone}`}</p>
              </div>
              <button className="close-btn" aria-label={t('common.close')} onClick={closeModal}>
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>

            {isChart ? (
              <div className="info-options">
                <Link to={`/jodi_chart/${data.game_name}`} className="info-option">
                  <span className="info-option-icon" aria-hidden="true"><FontAwesomeIcon icon={faGrip} /></span>
                  <span className="info-option-text">
                    <span className="info-option-title">{t('modals.jodiChart')}</span>
                    <span className="info-option-sub">{t('modals.jodiChartSub')}</span>
                  </span>
                  <FontAwesomeIcon icon={faChevronRight} className="info-option-chevron" />
                </Link>
                <Link to={`/pana_chart/${data.game_name}`} className="info-option">
                  <span className="info-option-icon" aria-hidden="true"><FontAwesomeIcon icon={faListOl} /></span>
                  <span className="info-option-text">
                    <span className="info-option-title">{t('modals.panaChart')}</span>
                    <span className="info-option-sub">{t('modals.panaChartSub')}</span>
                  </span>
                  <FontAwesomeIcon icon={faChevronRight} className="info-option-chevron" />
                </Link>
              </div>
            ) : (
              <div className="support-tiles">
                <button type="button" className="support-tile is-call" onClick={()=>openDialpad(`+91${data.phone}`)}>
                  <span className="support-tile-icon" aria-hidden="true"><FontAwesomeIcon icon={faPhone} /></span>
                  <span className="support-tile-label">{t('modals.callNow')}</span>
                </button>
                <a target="_blank" rel="noreferrer" href={`https://wa.me/+91${data.phone}?text=Hello !!`} className="support-tile is-whatsapp">
                  <span className="support-tile-icon" aria-hidden="true"><FontAwesomeIcon icon={faWhatsapp} /></span>
                  <span className="support-tile-label">{t('modals.whatsapp')}</span>
                </a>
              </div>
            )}
          </div>
        </div>
  );
};

export default CommonModalPopup;
